import { render, staticRenderFns } from "./data-access-and-restriction-form.vue?vue&type=template&id=e4800efc"
import script from "./data-access-and-restriction-form.vue?vue&type=script&lang=js"
export * from "./data-access-and-restriction-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports